// extracted by mini-css-extract-plugin
export var label = "_e1-1";
export var reminder = "_e1-0";